import React from 'react';
import { Box, Typography, Link, Grid, Divider } from '@mui/material';
import { lightColours } from '../styles/colours';
import { getTopCalculators, getMainCalculators } from '../utils/calculatorRegistry';

const Footer = () => {
  const mainCalculators = getMainCalculators();
  const topCalculators = getTopCalculators(8);
  const salaryCalculators = topCalculators.filter(calc => calc.category === 'salary-specific');

  return (
    <Box
      sx={{
        bgcolor: lightColours.footer,
        color: 'white',
        padding: { xs: 3, md: 4 },
        marginTop: 'auto',
        position: 'relative',
      }}
    >
      {/* Calculator Links Section - Fix orphan pages */}
      <Grid container spacing={4} sx={{ mb: 4 }}>
        <Grid item xs={12} md={4}>
          <Typography variant="h6" sx={{ 
            fontWeight: 'bold', 
            mb: 2, 
            color: 'white',
            textAlign: { xs: 'left', md: 'left' }
          }}>
            Main Calculators
          </Typography>
          <Box sx={{ textAlign: { xs: 'left', md: 'left' } }}>
            {mainCalculators.map((calc) => (
              <Link
                key={calc.id}
                href={calc.url}
                sx={{
                  display: 'block',
                  color: 'rgba(255, 255, 255, 0.8)',
                  textDecoration: 'none',
                  mb: 1.5,
                  fontSize: '0.95rem',
                  '&:hover': { 
                    color: 'white',
                    textDecoration: 'underline' 
                  },
                }}
              >
                {calc.name}
              </Link>
            ))}
          </Box>
        </Grid>
        
        <Grid item xs={12} md={8}>
          <Typography variant="h6" sx={{ 
            fontWeight: 'bold', 
            mb: 2, 
            color: 'white',
            textAlign: { xs: 'left', md: 'left' }
          }}>
            Popular Salary Calculators
          </Typography>
          <Box sx={{ textAlign: { xs: 'left', md: 'left' } }}>
            <Grid container spacing={2}>
              {salaryCalculators.map((calc) => (
                <Grid item xs={6} sm={4} md={3} key={calc.id}>
                  <Link
                    href={calc.url}
                    sx={{
                      display: 'block',
                      color: 'rgba(255, 255, 255, 0.8)',
                      textDecoration: 'none',
                      mb: 1.5,
                      fontSize: '0.875rem',
                      padding: '2px 0',
                      '&:hover': { 
                        color: 'white',
                        textDecoration: 'underline' 
                      },
                    }}
                  >
                    {calc.name}
                  </Link>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>
      </Grid>
      
      <Divider sx={{ bgcolor: 'rgba(255, 255, 255, 0.2)', mb: 3 }} />
      
      {/* Legal Links */}
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Link
          href="/privacy-policy"
          sx={{
            color: 'white',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          Privacy Policy
        </Link>{' | '}
        <Link
          href="/terms-of-service"
          sx={{
            color: 'white',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          Terms of Service
        </Link>{' | '}
        <Link
          href="/cookie-policy"
          sx={{
            color: 'white',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          Cookie Policy
        </Link>{' | '}
        <Link
          component="button"
          onClick={() => window.dispatchEvent(new CustomEvent('openCookieSettings'))}
          sx={{
            color: 'white',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            fontSize: 'inherit',
            fontFamily: 'inherit',
          }}
        >
          Cookie Settings
        </Link>
      </Box>

      <Typography variant="body2" sx={{ textAlign: 'center', mb: 1 }}>
        © 2025 SalaryTools.co.uk. All rights reserved.
      </Typography>
      
      <Typography variant="caption" sx={{ display: 'block', textAlign: 'center' }}>
        Information is provided solely for illustrative purposes. We recommend consulting a qualified professional before making financial decisions.
      </Typography>
    </Box>
  );
};

export default Footer;
